import React from 'react';
import SkillsChart from "./chart";
import SkillsSlider from "./slider";
import { navigateTo } from "gatsby-link";

const HomeSkills = () => {

    return (
        <section className="section-c section-3">
            <div className="section-title">
                <h2>My technical skills</h2>
            </div>
            <SkillsChart></SkillsChart>
            <SkillsSlider></SkillsSlider>
            <div className="button-wrapper">
                <button onClick={() => navigateTo('/skills')} className="animated  btn btn-primary hvr-grow-shadow">Details</button>
            </div>
        </section>
    )
};

export default HomeSkills;


// WEBPACK FOOTER //
// ./src/components/home/Skills/index.js